import {formatJobDate, formatJobTime} from './job-schedule-format'
import type {TimeEntry} from './schemas'

export function formatTimeEntryRange(
    entry: Pick<TimeEntry, 'startDate' | 'startTime' | 'endDate' | 'endTime' | 'durationHours'>,
): string {
    return `${formatJobDate(entry.startDate)} ${formatJobTime(entry.startTime)} – ${formatJobDate(entry.endDate)} ${formatJobTime(entry.endTime)} (${entry.durationHours} hrs)`
}
